import React, { useCallback, useState, useMemo } from 'react';
import { Container, Radio, List, ListItem, Text } from '@groupelacentrale/contact-storybook';
import { keypressCallback } from 'utils';

interface Props {
  value?: string;
  versionList: string[];
  eligibleVersionList: string[];
  touched?: boolean;
  error?: string;
  onVersionChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setFieldValue: (field: string, value: unknown, shouldValidate?: boolean | undefined) => void;
}

const NB_LIST = 15;

const findPage = (version: string[], value: string) => {
  const index = version.findIndex(v => v === value);
  return index > 0 ? Math.ceil((index + 1) / NB_LIST) : 1;
};

const VersionList: React.ForwardRefRenderFunction<HTMLDivElement, Props> = (
  { value, eligibleVersionList, touched, error, setFieldValue, onVersionChange },
  ref,
) => {
  const [page, setPage] = useState(value ? findPage(eligibleVersionList, value) : 1);
  const totalPages = useMemo(() => Math.round(eligibleVersionList.length / NB_LIST), [eligibleVersionList]);

  const addPage = useCallback(() => setPage(p => p + 1), []);

  const onVersionSelect = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setPage(1);
      onVersionChange(e);
    },
    [onVersionChange],
  );

  return (
    <div className="field-wrapper version-list" ref={ref}>
      <Text className="field-label">Version</Text>
      <Container bordered rounded>
        <List>
          {eligibleVersionList.slice(0, NB_LIST * page).map(option => {
            const handleKeyPress = keypressCallback(() => setFieldValue('version', option), 'data-option');
            return (
              <ListItem key={option} tabIndex={0} data-option={option} onKeyPress={handleKeyPress}>
                <span
                  className={
                    eligibleVersionList && !eligibleVersionList.includes(option.toString()) ? 'not-eligible' : undefined
                  }
                >
                  <Radio
                    name="version"
                    theme="primary"
                    value={option}
                    label={option}
                    checked={value === option}
                    onChange={onVersionSelect}
                  />
                </span>
              </ListItem>
            );
          })}
        </List>
      </Container>
      {touched && (
        <div id="formErrorMessage-version" className="formErrorMessage">
          {error}
        </div>
      )}
      {page < totalPages && (
        <span className="vehicle-version-list-button" onClick={addPage}>
          Afficher plus de versions
        </span>
      )}
    </div>
  );
};

const VehicleVersionList = React.forwardRef(VersionList);

export default VehicleVersionList;
